import Globals from '../../../globals/index'
import * as R from 'ramda'


export const enrichStateHistory = (state, processInstance) => {
    R.forEach(stateHistory => {
        if (stateHistory.changedByUserId !== null) {
            stateHistory.changedByUserName = Globals.selector.selectUserDisplayNameById(state, stateHistory.changedByUserId)
        } else {
            stateHistory.changedByUserName = 'System'
        }
    }, processInstance.processStateHistoryList)
}

export const enrichTaskList = (state, processInstance) => {
    R.forEach(processTask => {
        if (processTask.finishedByUserId !== null) {
            processTask.finishedByUserName = Globals.selector.selectUserDisplayNameById(state, processTask.finishedByUserId)
        }
    }, processInstance.processTaskList)
}


export const enrichComment = (state, comment) => {
    comment.author = Globals.selector.selectUserDisplayNameById(state, comment.createdByUserId)
    comment.isUserAuthor = Globals.selector.selectUserId(state) === comment.createdByUserId
}

export const enrichCommentList = (state, processInstance) => {
    R.forEach(comment => {
        enrichComment(state, comment)
    }, processInstance.processCommentList)
}

export const enrichProcessInstance = (state, processInstance) => {
    enrichStateHistory(state, processInstance)
    enrichCommentList(state, processInstance)
    enrichTaskList(state, processInstance)
}



// WEBPACK FOOTER //
// ./src/modules/process/state/instance-detail/enrich-process-instance.js